import { messageService } from './services/MessageService';
import { notificationService } from './services/NotificationService';
import type { ToastServiceAPI, NotificationServiceAPI } from './Message.types';

/**
 * API para mostrar toasts (mensajes temporales apilables)
 * Los toasts se apilan hasta 5 y cada uno tiene su propio timer
 *
 * @example
 * toast.success('Operación exitosa')
 * toast.error('Algo salió mal')
 * toast.info('Información')
 * toast.warning('Advertencia')
 */
export const toast: ToastServiceAPI = messageService;

/**
 * API para mostrar notificaciones (mensajes agrupados por tipo)
 * Las notificaciones se agrupan por color (brand/neutral)
 * Solo se muestra una notificación por tipo con contador
 *
 * @example
 * notification.brand('Nueva actualización disponible')
 * notification.neutral('Tienes un recordatorio')
 * notification.brand({ title: 'Mensaje', subtitle: 'De Juan', avatar: '...' })
 */
export const notification: NotificationServiceAPI = notificationService;

/**
 * API unificada de mensajes
 * Combina funcionalidad de toast y notification
 *
 * @example
 * // Toasts
 * notify.success('Guardado')
 * notify.error('Error')
 *
 * // Notificaciones (se agrupan)
 * notify.brand('Novedad')
 * notify.neutral('Recordatorio')
 */
export const notify = {
  // Métodos de toast (se apilan)
  success: messageService.success.bind(messageService),
  error: messageService.error.bind(messageService),
  info: messageService.info.bind(messageService),
  warning: messageService.warning.bind(messageService),
  show: messageService.show.bind(messageService),
  dismiss: messageService.dismiss.bind(messageService),
  configure: messageService.configure.bind(messageService),

  // Métodos de notification (se agrupan)
  brand: notificationService.brand.bind(notificationService),
  neutral: notificationService.neutral.bind(notificationService),
  dismissNotification: notificationService.dismissGroup.bind(notificationService),
  configureNotification: notificationService.configure.bind(notificationService),
};
